import clsx from "clsx";

import { TooltipIcon } from "../../../../components";
import {
  MALICIOUS_FILES_ICON,
  MALICIOUS_FILES_TOOLTIP,
  MALWARE_CONFIG_C2_ICON,
  MALWARE_CONFIG_C2_TOOLTIP,
  MALWARE_CONFIG_ICON,
  MALWARE_CONFIG_TOOLTIP
} from "./consts";
import styles from "./malware-config.module.scss";

type Props = {
  showMaliciousFiles?: boolean;
  showMalwareConfig?: boolean;
  variant?: "c2" | "config";
  className?: string;
};

const MalwareConfigAnnotationIcons = ({
  showMaliciousFiles = false,
  showMalwareConfig = false,
  variant = "config",
  className
}: Props) => {
  if (!showMaliciousFiles && !showMalwareConfig) return null;

  const isC2 = variant === "c2";

  return (
    <span className={clsx(styles.annotation_icons, className)}>
      {showMaliciousFiles && (
        <TooltipIcon
          icon={MALICIOUS_FILES_ICON}
          message={MALICIOUS_FILES_TOOLTIP}
          data-testid="malicious-files"
        />
      )}
      {showMalwareConfig && (
        <TooltipIcon
          icon={isC2 ? MALWARE_CONFIG_C2_ICON : MALWARE_CONFIG_ICON}
          message={isC2 ? MALWARE_CONFIG_C2_TOOLTIP : MALWARE_CONFIG_TOOLTIP}
          data-testid="malware-config"
        />
      )}
    </span>
  );
};

export default MalwareConfigAnnotationIcons;
